const Color = {
    base1: '#003291',
    base2: '#1D6DEE',
    base3: '#1D6DEE',
    base4: '#003291',
    base5: '#001F5C',
    base6: '#003291',

    secondary1: '#1D6DEE',
    secondary2: '#99C0FF',
    secondary3: '#D3E8FF',

    active: '#003291',
    activeDark: '#001F5C',
    neutral1: '#313131',
    neutral2: '#656565',
    neutral3: '#ADADAD',
    neutral4: '#D7D7D7',
    neutral5: '#F5F5F5',

    white: '#ffffff',
    black: '#000000',
    green: '#26CA7A',
    yellow: '#fce900',
    transparent: 'transparent',
    warning: '#FF3535',
    warningStrong: '#C00000',
    warningYellow: '#EED202',

    lightPurple: '#D3E8FF',

    primary: '#003291',
    secondary: '#1D6DEE'
}

module.exports = {
    Color
}
